// import { pg, filter } from '../utils/query';
import HTTP from './axios';

const CompanyEconocardService = {
  one: (id) => HTTP.get(`/companyEco/${id}`).then((response) => response.data),
  verifyByCNPJ: (cnpj) => HTTP.get(`/companyEco/${cnpj}/verifyByCNPJ`).then((response) => response.data),
};

export default CompanyEconocardService;
